import { usePool, useSaleRate } from '@trustpad/launchpad';

import * as React from 'react';
import { NftPoolConfig } from 'src/features/pools/types';

import { fNum } from '~utils';

export function PoolRate() {
  const { pool } = usePool<NftPoolConfig>();
  const { fundToken, token, sale } = pool;
  const { currencyPerToken, tokensPerCurrency } = useSaleRate();

  if (pool.isNft) {
    return null;
  }

  if (!sale.rate) {
    return <div className="text-2xl brand-text">Rate TBA</div>;
  }

  if (sale.rateString) {
    return (
      <div>
        <div className="text-2xl brand-text">{sale.rateString}</div>
        <div className="text-sm brand-text">
          1 {token.symbol} = {fNum(currencyPerToken, 10)} {fundToken.symbol} (avg)
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="text-2xl brand-text">
        1 {fundToken.symbol} = {fNum(tokensPerCurrency)} {token.symbol}
      </div>
      <div className="text-lg brand-text">
        1 {token.symbol} = {fNum(currencyPerToken, 10)} {fundToken.symbol}
      </div>
    </div>
  );
}
